import Seo, { breadcrumbSchema } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { Overline } from "@/components/Btn";
import { Breadcrumb } from "@/components/Breadcrumb";
import { COMPANY } from "@/data/company";

export function MentionsLegales() {
  const crumbs = [{ label: "Accueil", to: "/" }, { label: "Mentions légales", to: "/mentions-legales/" }];
  return (
    <>
      <Seo title="Mentions légales | Ronalp Enseigne" description="Mentions légales du site Ronalp Enseigne." path="/mentions-legales/" noindex jsonLd={[breadcrumbSchema(crumbs)]} />
      <LegalShell title="Mentions légales" crumbs={crumbs}>
        <h2>Éditeur du site</h2>
        <p><strong>{COMPANY.name}</strong> est une marque de <strong>{COMPANY.legal.company}</strong> ({COMPANY.legal.form}).</p>
        <p>Siège social : {COMPANY.address.street}, {COMPANY.address.postalCode} {COMPANY.address.city}, {COMPANY.address.country}.<br />Téléphone : {COMPANY.phone} — Email : {COMPANY.email}</p>
        <h2>Informations juridiques</h2>
        <ul className="list-none space-y-1">
          <li>Dénomination : {COMPANY.legal.company}</li>
          <li>Forme juridique : {COMPANY.legal.form}</li>
          <li>SIREN : {COMPANY.legal.siren}</li>
          <li>SIRET (siège) : {COMPANY.legal.siret}</li>
          <li>Numéro de TVA intracommunautaire : {COMPANY.legal.tva}</li>
          <li>RCS : {COMPANY.legal.rcs} (inscrit le {COMPANY.legal.rcsDate})</li>
        </ul>
        <h2>Hébergement</h2>
        <p>Ce site est hébergé sur une infrastructure cloud. Les informations d'hébergement complètes seront précisées lors de la mise en production.</p>
        <h2>Propriété intellectuelle</h2>
        <p>L'ensemble des contenus (textes, images, logo) est la propriété de {COMPANY.legal.company}, sauf mention contraire. Toute reproduction sans autorisation est interdite.</p>
        <h2>Responsabilité</h2>
        <p>Les informations présentées sont fournies à titre indicatif et peuvent évoluer. {COMPANY.legal.company} ne saurait être tenu responsable d'éventuelles erreurs ou omissions.</p>
        <p className="text-chrome-dark text-sm">Document à compléter avec le nom du directeur de publication et les coordonnées de l'hébergeur lors de la mise en production.</p>
      </LegalShell>
    </>
  );
}

export function Confidentialite() {
  const crumbs = [{ label: "Accueil", to: "/" }, { label: "Politique de confidentialité", to: "/politique-confidentialite/" }];
  return (
    <>
      <Seo title="Politique de confidentialité | Ronalp Enseigne" description="Politique de confidentialité et traitement des données personnelles du site Ronalp Enseigne." path="/politique-confidentialite/" noindex jsonLd={[breadcrumbSchema(crumbs)]} />
      <LegalShell title="Politique de confidentialité" crumbs={crumbs}>
        <h2>Collecte des données</h2>
        <p>Les données transmises via le formulaire de devis (nom, entreprise, email, téléphone, description du projet et fichiers éventuels) sont utilisées uniquement pour traiter votre demande et vous recontacter.</p>
        <h2>Conservation</h2>
        <p>Vos données sont conservées le temps nécessaire au traitement de votre demande et à la relation commerciale.</p>
        <h2>Vos droits</h2>
        <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, contactez-nous à {COMPANY.email}.</p>
        <h2>Cookies</h2>
        <p>Le site peut utiliser des cookies de mesure d'audience. Vous pouvez les refuser via les paramètres de votre navigateur.</p>
      </LegalShell>
    </>
  );
}

function LegalShell({ title, crumbs, children }) {
  return (
    <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-10 lg:py-16">
      <Breadcrumb items={crumbs} />
      <Reveal className="mt-8">
        <Overline>Informations</Overline>
        <h1 className="mt-5 text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white">{title}</h1>
        <div className="mt-8 space-y-4 text-slate-300 leading-relaxed [&>h2]:text-xl [&>h2]:font-bold [&>h2]:text-white [&>h2]:pt-4">
          {children}
        </div>
      </Reveal>
    </section>
  );
}
